import { render } from "./RhCaptcha.vue?vue&type=template&id=2f9c86bd&ts=true"
import script from "./RhCaptcha.vue?vue&type=script&lang=ts"
export * from "./RhCaptcha.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__